export const SUCCESS_CREATE = 'データは正常に作成されました。';
export const SUCCESS_EDIT = 'データは正常に編集されました。';
export const SUCCESS_DELETE = 'データは正常に削除されました。';
export const SUCCESS_PASSWORD_CREATE = 'パスワードは正常に作成されました。';
export const SUCCESS_LOGIN = '正常にログインしました。';
export const ERROR = 'エラーが発生しました。';
export const ERROR_CONFLICT = 'コードが重複しています。';
